import React, { useContext } from 'react';
import {
  Card,
  CardTitle,
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { Duplicate } from '@one-thd/sui-icons';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from "../../AddToConstants";


export const CopyListTile = ({ }) => {
  const {
    setScreen
  } = useContext(AddToContext);
  return (
    <div
      onClick={() => { setScreen(SCREENS.COPY_LIST_SUMMARY); }}
      className='sui-mt-8 sui-cursor-pointer'
    >
      <Card data-testid="copy-list" disablePadding disableGutters orientation="horizontal">
        <div className='sui-w-24 sui-flex sui-justify-center sui-items-center'>
          <Duplicate size='large' />
        </div>
        <div className="sui-py-3 sui-pr-1">
          <CardTitle header="Copy from Your Lists" headerWeight="bold" />
          <CardBody>
            <Typography>Pull in items from one or more of your existing lists.</Typography>
          </CardBody>
        </div>
      </Card>
    </div>
  );
};

CopyListTile.displayName = 'CopyListTile';

CopyListTile.propTypes = {};

CopyListTile.defaultProps = {};

// CopyListTile.dataModel = extend({});

